import axios from "axios";
import AxiosClient from "../../services/axios.services";

class CountryUserServices {
  getCountriesUser = params =>
    AxiosClient.get("/api/app/head_clima_pais/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getCountryUser = id =>
    AxiosClient.get(`/api/app/head_clima_pais/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCountryUser = data =>
    AxiosClient.post("/api/app/head_clima_pais/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editCountryUser = (id, data) =>
    AxiosClient.put(
      `/api/app/head_clima_pais/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteCountryUser = id =>
    AxiosClient.delete(`/api/app/head_clima_pais/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CountryUserServices();